import { Routes, Route, Navigate } from "react-router-dom";
import JoinClub from "./JoinClub";
import BadminQueueApp from "./BadminQueueApp";
import AdminRoute from "./routes/AdminRoute";
import SelectMode from "./components/SelectMode";
import SelectSession from "./SelectSession";
import SessionGate from "./SessionGate"
import GoogleLogin from "./GoogleLogin"
import PlayerProfile from "./PlayerProfile"
import MyProfileGate from "./MyProfileGate"
import AdminRegistrations from "./Tournament";
import AdminGuard from "./routes/AdminGuard";
import PWAInstallBanner from "./components/layout/PWAInstallBanner";

import OverallRankings from "./Rankings"
import SibolRegistration from "./tournament/sibol/TournamentRegistrationElite"
import AdminPlayersList from "./AdminPlayersList";
import AdminDashboard from "./AdminDashboard";
import Reservations from "./Reservations";
import ReservationsPage from "./ReservationsPage";

import { useAuth } from "./context/AuthContext";
import GlobalLogoutLoader from "./components/GlobalLogoutLoader";
import ProtectedRoute from "./ProtectedRoute";
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from "./context/ThemeContext";


function App() {
  const { isLoggingOut } = useAuth();
  return (
    <ThemeProvider>
      <Toaster
        position="top-right" // Options: top-left, top-right, bottom-left, bottom-right
        reverseOrder={false} // Newest toast appears at the top of the stack
      />
      {isLoggingOut && <GlobalLogoutLoader />}
      <PWAInstallBanner />
      <Routes>
        <Route path="/select-mode" element={<SelectMode />} />
        <Route path="/join" element={<JoinClub />} />
        <Route path="/signin" element={<GoogleLogin />} />
        <Route path="/u/:username" element={<PlayerProfile />} />
        <Route path="/me" element={<MyProfileGate />} />

        <Route
          path="/rankings"
          element={
            <ProtectedRoute>
              <OverallRankings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tournament"
          element={
            <SibolRegistration />
          }
        />
         <Route
          path="/reservations"
          element={
            <ProtectedRoute>
              <ReservationsPage />
            </ProtectedRoute>
          }
        />
        {/* 🔐 ADMIN BUT NO SESSION REQUIRED */}
        <Route
          path="/admin/select-session"
          element={
            <AdminGuard>
              <SelectSession />
            </AdminGuard>
          }
        />
        <Route
          path="/admin/players"
          element={
            <AdminGuard>
              <AdminPlayersList />
            </AdminGuard>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <AdminGuard>
              <AdminDashboard />
            </AdminGuard>
          }
        />
         <Route
          path="/admin/reservations"
          element={
            <AdminGuard>
              <Reservations />
            </AdminGuard>
          }
        />
        <Route path="/admin/registrations" element={<AdminGuard><AdminRegistrations /></AdminGuard>} />
        {/* 🔐 ADMIN + SESSION REQUIRED */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <SessionGate>
                <BadminQueueApp />
              </SessionGate>
            </AdminRoute>
          }
        />

        <Route path="*" element={<Navigate to="/join" replace />} />
      </Routes>
    </ThemeProvider>

  );
}

export default App;
